import { ShieldCheck, ShieldAlert, ShieldQuestion } from "lucide-react";

const STYLE = {
  verified: { cls: "bg-emerald-100 text-emerald-800", Icon: ShieldCheck },
  submitted: { cls: "bg-sky-100 text-sky-800", Icon: ShieldQuestion },
  expired: { cls: "bg-amber-100 text-amber-800", Icon: ShieldAlert },
  none: { cls: "bg-secondary text-muted-foreground", Icon: ShieldQuestion },
};

// The only DBS information a customer ever sees. Certificates are never exposed.
export function DbsPill({ dbs, className = "" }) {
  const s = STYLE[dbs?.status || "none"];
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${s.cls} ${className}`}
      data-testid={`dbs-pill-${dbs?.status || "none"}`}>
      <s.Icon className="h-3.5 w-3.5" /> {dbs?.label || "DBS not provided"}
    </span>
  );
}

export default function DbsStatusBlock({ dbs }) {
  const status = dbs?.status || "none";
  const s = STYLE[status];
  return (
    <div className={`rounded-2xl border p-4 ${status === "verified" ? "border-emerald-200 bg-emerald-50/60" : status === "submitted" ? "border-sky-200 bg-sky-50/60" : status === "expired" ? "border-amber-200 bg-amber-50/60" : "border-border bg-secondary/40"}`}
      data-testid={`dbs-status-${status}`}>
      <div className="flex items-center gap-2">
        <s.Icon className={`h-5 w-5 ${status === "verified" ? "text-emerald-700" : status === "submitted" ? "text-sky-700" : status === "expired" ? "text-amber-700" : "text-muted-foreground"}`} />
        <p className="font-semibold text-sm">{dbs?.label}</p>
      </div>
      <p className="text-sm text-muted-foreground mt-2">{dbs?.message}</p>
      <p className="text-xs text-muted-foreground mt-2">{dbs?.freshness_note}</p>
    </div>
  );
}
